import PropTypes from 'prop-types';
import AccountLoginInfo from './AccountLoginInfo';
import AccountUserInfo from './AccountUserInfo';
import validate from './validate';
import { ScModalFinalForm } from '@app/components/Base/ScFinalForm/ModalFinalForm';

const propTypes = {
    isShow: PropTypes.bool,
    initialValues: PropTypes.shape({}),
    isEdit: PropTypes.bool,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    onChangeAvatar: PropTypes.func,
};

const AccountModal = ({
    isShow,
    isEdit,
    initialValues,
    onClose,
    onSubmit,
    onChangeAvatar,
}) => (
    <>
        <ScModalFinalForm
            open={isShow}
            onClose={onClose}
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            title="Thông tin tài khoản người dùng"
            width={900}
            className="full-height"
        >
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-md-12 col-sm-6">
                            <AccountUserInfo
                                onChangeAvatar={onChangeAvatar}
                                initialValues={initialValues}
                            />
                        </div>
                        <div className="col-md-12 col-sm-6">
                            {!isEdit ? <AccountLoginInfo /> : null}
                        </div>
                    </div>
                </div>
            </div>
        </ScModalFinalForm>
    </>
);

AccountModal.propTypes = propTypes;

export default AccountModal;
